// Mirrors MANDATORY_PHOTO_TYPES in the dashboard creation flow
// (dashboard/src/pages/patient/CreationProcess/UploadPatientPhotos.tsx): same
// ids, labels and grid order. Candidate to move into @odo/shared-ui so the
// two apps cannot drift.
export const CREATION_PHOTO_SLOT_IDS = [
    'front_buccal',
    'right_buccal',
    'left_buccal',
    'upper_occlusal',
    'lower_occlusal',
    'profile_right',
    'profile_left',
    'frontal_rest',
    'frontal_smile'
] as const;

export type CreationPhotoSlotId = (typeof CREATION_PHOTO_SLOT_IDS)[number];

export const CREATION_PHOTO_SLOT_LABELS: Readonly<Record<CreationPhotoSlotId, string>> = {
    front_buccal: 'Front Buccal',
    right_buccal: 'Right Buccal',
    left_buccal: 'Left Buccal',
    upper_occlusal: 'Upper Occlusal',
    lower_occlusal: 'Lower Occlusal',
    profile_right: 'Profile Right',
    profile_left: 'Profile Left',
    frontal_rest: 'Frontal Rest',
    frontal_smile: 'Frontal Smile'
};
